import {
  DateRangePickerProps,
  DefaultDateRangePresetId,
  defaultPresets,
} from '@branch-messenger/willow-ui'
import { formatISO, parseISO } from 'date-fns'

type GetDateRangePresetProps = {
  to?: string
  from?: string
  presetId?: DateRangePickerProps['presetId']
  presets?: DateRangePickerProps['presets']
  defaultDateRangePreset?: DefaultDateRangePresetId
}

export const getDateRangeFromPreset = ({
  to,
  from,
  presetId = 'all_time',
  presets = defaultPresets,
}: GetDateRangePresetProps) => {
  const preset = presets?.find(preset => preset.id === presetId)

  if (to && from) {
    return {
      toString: to,
      fromString: from,
      to: parseISO(to),
      from: parseISO(from),
    }
  }

  return {
    toString: preset?.to && formatISO(preset?.to),
    fromString: preset?.from && formatISO(preset?.from),
    to: preset?.to,
    from: preset?.from,
    preset,
  }
}
